module.exports = __webpack_public_path__ + "img/61501af.jpg";